import {initLocalStorage} from '../../js/util/LocalStorage'
import {getWorkScheduleSelectedYear} from '../../js/administration/workSchedule/utils'
import {initStore} from '../../js/redux/store'
import createRootReducer from './reducer'
import $ from '../../js/alias/jquery'
import LicenseCountDownTip from '../../js/components/licenseCountDownTip/LicenseCountDownTip'
import ContactSupportDraggablePopupContainer from '../../js/support/supportForm/ContactSupportDraggablePopupContainer'
import {getSupportPopupInfoFromLocalStorage} from '../../js/support/supportForm/utils'
import SupportQuestionButton from '../../js/support/supportForm/SupportQuestionButton'

export default function initApplication() {
    const INIT_DATA = window.__INIT_APP_DATA__

    // load data from local storage
    initLocalStorage(INIT_DATA.LOGGED_IN_USER.id)

    INIT_DATA.WORK_SCHEDULE = {
        SELECTED_YEAR: getWorkScheduleSelectedYear()
    }

    INIT_DATA.SUPPORT = {
        ...INIT_DATA.SUPPORT,
        POPUP_INFO: {
            ...getSupportPopupInfoFromLocalStorage(),
        },
    }

    initStore(INIT_DATA, createRootReducer)

    initCommonComponents()
}

function initCommonComponents() {
    const $body = $('body')
    new LicenseCountDownTip().init($body)
    new SupportQuestionButton().init($('.contactSupportButtonPlaceholder'))
    new ContactSupportDraggablePopupContainer().init()
}


// WEBPACK FOOTER //
// ./web/actiplans/js/initAplication.js